<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="pageConfig.title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onRefresh()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <app-base-outbox-messages-detail [model]="model">
    </app-base-outbox-messages-detail>

    <!-- items -->
    <div
      class="row tw-justify-center tw-mt-3"
      *ngIf="model?.bulkRecipients.length > 0"
    >
      <div class="tw-w-full">
        <h5
          class="tw-mr-2 tw-my-4 tw-text-primary-700 dark:tw-text-primary-200"
        >
          {{ "common.bulkSendDetail" | translate }}
        </h5>
        <app-dynamic-table
          [config]="pageConfig?.tableConfig"
          [loading]="pageConfig.loading"
          [isEmpty]="pageConfig?.isEmpty"
          [hasError]="pageConfig?.hasError"
          (sortObject)="getSortItems($event)"
          (comparisonObjects)="getComparisonObjects($event)"
          (pageNumber)="changePageNumber($event)"
          (pageSize)="changePageSize($event)"
        >
          <ng-container
            table-body
            *ngIf="model?.bulkRecipients && !pageConfig.loading"
          >
            <ng-container
              *ngFor="let item of model?.bulkRecipients; let i = index"
            >
              <tr>
                <!-- index -->
                <td class="tw-text-center !tw-p-4">
                  {{ paginationModel?.firstIndex + i }}
                </td>

                <!-- bulkRecipientId -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.bulkRecipientId"
                  >
                  </td-value>
                </td>
                <!-- state -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.state"
                  ></td-value>
                </td>
                <!-- city -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.city"
                  ></td-value>
                </td>
                <!-- area -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.area"
                  ></td-value>
                </td>
                <!-- guildName -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.guildName"
                  ></td-value>
                </td>
                <!-- sunGuildName -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.subGuildName"
                  ></td-value>
                </td>
                <!-- preFix -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.preFix"
                  ></td-value>
                </td>
                <!-- zipCode -->
                <td>
                  <td-value
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.zipCode"
                  ></td-value>
                </td>
                <!-- genderTye -->
                <td>
                  {{ item?.genderTye | enumToText : GenderTypeEnumValues }}
                </td>
                <!-- simType -->
                <td>
                  {{ item?.simType | enumToText : SimTypeEnumValues }}
                </td>
                <!-- aggregatorType -->
                <td class="tw-py-2">
                  <!-- mci -->
                  <div
                    class="text-mci tw-flex tw-items-center tw-justify-center"
                    *ngIf="item.aggregatorType == SmsAggregator.MCI"
                  >
                    <span>
                      {{
                        item.aggregatorType
                          | enumToText : SmsAggregatorEnumValues
                      }}
                    </span>
                    <img [src]="mciImage" class="tw-mx-3" width="23" />
                  </div>
                  <!-- mtn -->
                  <div
                    class="text-mtn tw-flex tw-items-center tw-justify-center"
                    *ngIf="item.aggregatorType == SmsAggregator.Irancell"
                  >
                    <span>
                      {{
                        item.aggregatorType
                          | enumToText : SmsAggregatorEnumValues
                      }}
                    </span>
                    <img
                      src="/assets/media/svg/operator/mtn.svg"
                      class="tw-mx-3"
                      width="23"
                    />
                  </div>
                  <!-- rightel -->
                  <div
                    class="text-rightel tw-flex tw-items-center tw-justify-center"
                    *ngIf="item.aggregatorType == SmsAggregator.Rightel"
                  >
                    <span>
                      {{
                        item.aggregatorType
                          | enumToText : SmsAggregatorEnumValues
                      }}
                    </span>
                    <img [src]="rightelImage" class="tw-mx-3" width="23" />
                  </div>
                  <!-- other -->
                  <span
                    class="text-brown tw-font-semibold"
                    *ngIf="item.aggregatorType == SmsAggregator.Other"
                  >
                    {{
                      item.aggregatorType | enumToText : SmsAggregatorEnumValues
                    }}
                  </span>
                </td>
                <!-- fromIndex -->
                <td>
                  <td-value
                    type="number"
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.fromIndex"
                  >
                  </td-value>
                </td>
                <!-- count -->
                <td>
                  <td-value
                    type="number"
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.bulkRecipientCount | numberSeparator"
                  ></td-value>
                </td>
                <!-- totalCount -->
                <td>
                  <td-value
                    type="number"
                    copyToClipboard
                    class="tw-font-semibold"
                    [value]="item?.totalCount | numberSeparator"
                  ></td-value>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </app-dynamic-table>
      </div>
    </div>
  </div>
</app-page-body>
